export default "__VITE_ASSET__CuDQHAB9__"